import { getMonitoringList, setConfirm } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'monitoring',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *getMonitoringList({ payload }, { call, put }) {
      const res = yield call(getMonitoringList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveMonitoringList',
          payload: res.data,
        });
      }
    },
    *setConfirm({ payload }, { call }) {
      return yield call(setConfirm, payload);
    },
  },
  reducers: {
    saveMonitoringList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
